var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" CTR "),_c('info-tooltip',{attrs:{"content":"Click through rate is the number of clicks the ad received divided by the number of impressions."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }